import { Checkbox } from "@mui/material";
import React, { FunctionComponent, useEffect } from "react";
import { styled } from "@iventis/styles";
import { IventisCellEditorParams } from "../types/data-table.types";

/**
 * Checkbox style cell renderer for data table column of type "boolean". Used instead of cell editor
 */
export const CheckboxCellRenderer: FunctionComponent<IventisCellEditorParams> = ({ node, value, eGridCell, colDef }) => {
    useEffect(() => {
        const keydown = (e: KeyboardEvent) => {
            if (e.code === "Space" || e.code === "Enter") {
                onclick();
            }
        };
        const onclick = () => {
            if (node.data.canEdit) {
                // Update the value of the checkbox
                node.setDataValue(colDef.field, !value);
            }
        };
        eGridCell.addEventListener("click", onclick);
        eGridCell.addEventListener("keydown", keydown);
        return () => {
            eGridCell.removeEventListener("click", onclick);
            eGridCell.removeEventListener("keydown", keydown);
        };
    }, [value]);

    return (
        <>
            <StyledCheckbox disabled={!node.data.canEdit} value={value} checked={value} />
        </>
    );
};

const StyledCheckbox = styled(Checkbox)`
    width: 100%;
    height: 100%;
    :hover {
        background-color: transparent;
    }
`;
